module.exports = __webpack_public_path__ + "static/img/brand3.6e64563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand3.png
// module id = lgXH
// module chunks = 1